import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { formatBytes, getFileExtension } from '../utils/imageOps';

const { FiImage, FiTrash2 } = FiIcons;

const FORMAT_BADGE: Record<string, string> = {
  heic: 'bg-orange-100 text-orange-600 dark:bg-orange-900/30 dark:text-orange-400',
  heif: 'bg-orange-100 text-orange-600 dark:bg-orange-900/30 dark:text-orange-400',
  tiff: 'bg-sky-100 text-sky-600 dark:bg-sky-900/30 dark:text-sky-400',
  tif:  'bg-sky-100 text-sky-600 dark:bg-sky-900/30 dark:text-sky-400',
  avif: 'bg-violet-100 text-violet-600 dark:bg-violet-900/30 dark:text-violet-400',
};

interface FileListItemProps {
  file: File;
  onRemove: (() => void) | null;
}

const FileListItem = ({ file, onRemove }: FileListItemProps) => {
  const ext = getFileExtension(file.name) || 'file';
  const badgeClass =
    FORMAT_BADGE[ext] ??
    'bg-indigo-100 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400';

  return (
    <div className="flex items-center justify-between p-3 bg-white/50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-700 hover:border-indigo-200 dark:hover:border-indigo-800 transition-colors">
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-10 h-10 shrink-0 rounded-lg bg-indigo-100 dark:bg-indigo-900/30 flex items-center justify-center text-indigo-500">
          <SafeIcon icon={FiImage} />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-semibold truncate text-slate-800 dark:text-slate-100" title={file.name}>
            {file.name}
          </p>
          <div className="flex items-center gap-2 mt-0.5">
            <span className={`text-[10px] font-bold uppercase px-1.5 py-0.5 rounded ${badgeClass}`}>
              {ext}
            </span>
            <span className="text-[10px] text-slate-400">{formatBytes(file.size)}</span>
          </div>
        </div>
      </div>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={`Remove ${file.name}`}
          className="text-slate-400 hover:text-red-500 p-2 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors ml-2 shrink-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500"
        >
          <SafeIcon icon={FiTrash2} />
        </button>
      )}
    </div>
  );
};

export default FileListItem;
